import {Button} from 'shells/button/button';
import {Card} from 'shells/card/card';
import {FormField} from 'shells/form/form-field';
import {PencilOutlineIcon} from 'shells/icon';
import {Stack} from 'shells/layout/stack/stack';
import {SelectWithIcon} from 'shells/select-picker/select-with-icon/select-with-icon';
import {Switch} from 'shells/switch/switch';
import {TextField} from 'shells/textfield/textfield';
import {Body} from 'shells/typography/body';

import {CreateOrEditModal} from '../../../../../setup/custom-fields/create-or-edit-modal/create-or-edit-modal';

import {
    ENTITY_OPTIONS,
    SINGLE_CHOICE_FIELD_TYPE_SELECT_OPTIONS,
    VIEWS_WITH_CHOICES,
    VIEWS_WITHOUT_PLACEHOLDER,
} from '../add-custom-field/consts';
import {SidebarPanelHeader} from '../sidebar-panel-header/sidebar-panel-header';

import type {EditCustomFieldPanelProps} from './types';

export function EditCustomFieldPanel(props: EditCustomFieldPanelProps) {
    const {existingField, panelView} = props;
    const showChoices = VIEWS_WITH_CHOICES.has(panelView);
    const showPlaceholder = !VIEWS_WITHOUT_PLACEHOLDER.has(panelView);

    return (
        <>
            <div>
                <SidebarPanelHeader title={props.title} onBack={props.onBack} />
                <div className='pad-16 flex flex-dir-col gap-24'>
                    <Stack isHorizontal={true} justifyContent='space-between' alignItems='center'>
                        <Body>Required</Body>
                        <Switch
                            isOn={props.requiredValue}
                            isRounded={true}
                            isSmall={true}
                            onChange={props.toggleRequired}
                        />
                    </Stack>
                    {props.showSingleChoiceFieldTypeToggle &&
                        props.singleChoicePresentation != null && (
                            <FormField innerId='field-type' label='Field type' noMargin={true}>
                                <SelectWithIcon
                                    name='field-type'
                                    options={SINGLE_CHOICE_FIELD_TYPE_SELECT_OPTIONS}
                                    value={props.singleChoicePresentation}
                                    onChange={(value: string) =>
                                        props.setSingleChoiceFieldType(
                                            value === 'dropdown' ? 'dropdown' : 'radio'
                                        )
                                    }
                                />
                            </FormField>
                        )}
                    <FormField innerId='label' label='Label' noMargin={true}>
                        <TextField
                            placeholder='Field label'
                            value={props.labelValue}
                            onChange={props.setLabel}
                        />
                    </FormField>
                    {showPlaceholder && (
                        <FormField innerId='placeholder' label='Placeholder' noMargin={true}>
                            <TextField
                                placeholder='Placeholder text'
                                value={props.placeholderValue}
                                onChange={props.setPlaceholder}
                            />
                        </FormField>
                    )}
                    <FormField innerId='entity' label='Entity' noMargin={true}>
                        <div className='no-click disabled'>
                            <SelectWithIcon
                                name='entity'
                                options={ENTITY_OPTIONS}
                                value={existingField.entityType}
                                onChange={() => {}}
                            />
                        </div>
                    </FormField>
                    {showChoices && (
                        <FormField innerId='choices' label='Field options' noMargin={true}>
                            <Stack spacing={8}>
                                {props.choiceDisplayLabels.map((choice) => (
                                    <Card key={choice} hasBorder={true} hasShadow={true}>
                                        <div className='pad-8'>
                                            <Body size='small'>{choice}</Body>
                                        </div>
                                    </Card>
                                ))}
                                <Button
                                    variant='text-primary'
                                    size='small'
                                    onClick={() => props.setIsEditModalOpen(true)}
                                    icon={PencilOutlineIcon}
                                    noPadding={true}
                                >
                                    Edit options
                                </Button>
                            </Stack>
                        </FormField>
                    )}
                </div>
            </div>
            {props.isEditModalOpen && (
                <CreateOrEditModal
                    onClose={() => props.setIsEditModalOpen(false)}
                    entityType={existingField.entityType}
                    isEditing={true}
                    fieldId={existingField.id}
                    refetchStagesets={() => Promise.resolve()}
                    canUpdateMultipleChoicesSetting={false}
                />
            )}
        </>
    );
}
